module.exports = __webpack_public_path__ + "static/mauritiusreisen-7fc20eabd18532bf413d25d0201758ac.svg";